import NavBar from './NavBar/NavBar';


const Header = () => {
    return (
        <>
            <NavBar />
        </>
    );
}

export default Header;